export default __webpack_public_path__ + "static/media/logo.6be01fbe.png";